import { call, put, select, takeEvery } from 'redux-saga/effects'

import {
  agentSourcedCreatorActionFailure,
  agentSourcedCreatorActionSuccess,
  unshortlistAgentSourcedCreator,
} from '@store/agentSourcedCreators/actions'
import { selectAgentSourcedCreators } from '@store/agentSourcedCreators/selectors'
import { selectAuthToken } from '@store/auth/selectors'
import { extractVerbatimErrorMessage } from '@store/discoveryRuns/api'
import { toast } from '@tribegroup'
import { networkRequest } from '@utils/networkRequest'

const creatorDisplayName = (creators: ReadonlyArray<any>, id: number): string => {
  const c = creators.find((x) => x.id === id)
  return (
    c?.creator_data?.fullname ?? c?.creator_data?.handle ?? c?.creator_data?.username ?? 'Creator'
  )
}

export function* unshortlistCreatorSaga(action: ReturnType<typeof unshortlistAgentSourcedCreator>) {
  try {
    const { creatorId, href, method } = action.payload
    const token: string = yield select(selectAuthToken)
    const response: {
      id: number
      status: string
      shortlisted: boolean
      links: unknown
    } = yield call(networkRequest, method, href, undefined, token)
    yield put(
      agentSourcedCreatorActionSuccess({
        creatorId,
        status: response.status as any,
        shortlisted: response.shortlisted ?? false,
        updatedLinks: response.links as any,
      }),
    )
    const creators: ReadonlyArray<any> = yield select(selectAgentSourcedCreators)
    yield call(toast, `Removed ${creatorDisplayName(creators, creatorId)} from shortlist`)
  } catch (e: any) {
    const message = extractVerbatimErrorMessage(e)
    yield put(
      agentSourcedCreatorActionFailure({
        creatorId: action.payload.creatorId,
        error: message,
      }),
    )
    yield call(toast, `Unshortlist failed: ${message}`)
  }
}

export default function* watchUnshortlistAgentSourcedCreator() {
  yield takeEvery(unshortlistAgentSourcedCreator.type, unshortlistCreatorSaga)
}
